<app-card [type]="3" [title]="'Request for password reset' | translate">
  <div cardBody3>
    <form [formGroup]="getPasswordResetTokenForm" (ngSubmit)="onSubmit()" vgFocusFirstInvalid [form]="getPasswordResetTokenForm">
      <div class="form-group">
        <label for="email"><i class="bi bi-envelope"></i> {{'common.label.email' | translate }}</label>
        <input id="email" type="text" [placeholder]="'common.placeholder.email' | translate" formControlName="email" class="form-control" />
        <vg-error-section
          [label]="'common.label.email' | translate"
          [group]="getPasswordResetTokenForm"
          controlName="email"
        ></vg-error-section>
      </div>
      <button [disabled]="loading" class="btn btn-primary rounded-pill float-right mt-2">
        <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
        <span>{{ 'common.button.save' | translate }}</span>
      </button>
    </form>
  </div>
</app-card>
